import React, { useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor, EuiSwitch} from '@elastic/eui';
import {ComboPaisesContainer as ComboPaises} from '../../../components/Combos/Paises/container';
import { CreateFechaMoment, ToSQL } from '../../../../../shared/utils/fecha';
import SelectorFecha from '../../../../../shared/components/Combos/Fecha';
import ComboTipoSociedad from '../../../components/Selectores/TipoSociedad/combo';

export const Formulario = (props)=>{
  let {onSave, selected, onClose} = props

  let [idSociedad,setIdSociedad] = useState(selected ? selected.idSociedad : undefined) 
  let [sociedad,setSociedad] = useState(selected ? selected.sociedad : undefined)
  let [cif,setCif] = useState(selected ? selected.cif : undefined) 
  let [referencia,setReferencia] = useState(selected ? selected.referencia : undefined) 
  let [pais,setPais] = useState(selected ? selected.codPais.toString() : [])
  let [fechaBaja, setFechaBaja] = useState(selected && selected.fechaBaja != null ? CreateFechaMoment(selected.fechaBaja) : null)
  let [domicilioFiscal, setDomicilioFiscal] = useState(selected ? selected.domicilioFiscal : undefined);
  let [tipo,setTipo] = useState(selected ? selected.tipo : undefined)
  let [facturacionCertificado, setFacturacionCertificado] = useState(selected ? selected.facturacion_Certificado : false);

  const getData = () =>{
    let data = {idSociedad: idSociedad, sociedad: sociedad, codPais: (Array.isArray(pais) ? pais[0].value : pais), 
                fechaBaja: (fechaBaja != null ? ToSQL(fechaBaja, "-") : null),
                domicilioFiscal: domicilioFiscal, tipo: tipo, facturacion_Certificado: facturacionCertificado
              }
    
    if(selected){
      return {dataSoc:{...selected,...data},idActual: selected.idSociedad}
    }else{return data}
  }

  const onSaveData = () =>{
    if(!comprobarErrores()){
      let newData = getData();
      onSave && onSave(newData)
    }
  }

  const comprobarErrores = () => {
    return (isInvalidIdSociedad || isInvalidSociedad || isInvalidPais)
  }

  const isInvalidIdSociedad = useMemo(() => {return idSociedad===undefined || idSociedad.trim()===""},[idSociedad])
  const isInvalidSociedad = useMemo(() => {return sociedad===undefined || sociedad.trim()===""},[sociedad])
  const isInvalidPais = useMemo(() => pais.length===0,[pais])


  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem grow={10}>
          <EuiFormRow fullWidth label="Sociedad" isInvalid={isInvalidSociedad}>
            <EuiFieldText fullWidth value={sociedad} name="txtSociedad" onChange={e => setSociedad(e.target.value)} isInvalid={isInvalidSociedad}/>
          </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem grow={2}>
        <EuiFormRow fullWidth label="Tipo">
          <ComboTipoSociedad fullWidth valueOfSelected={tipo} onChange={value => setTipo(value)}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    <EuiFlexGroup>
    <EuiFlexItem>
          <EuiFormRow label="Código" fullWidth isInvalid={false}>
            <EuiFieldText value={idSociedad} fullWidth name="txtIdSociedad" onChange={e => setIdSociedad(e.target.value)} isInvalid={false}/>
          </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
          <EuiFormRow label="Cif" fullWidth isInvalid={false}>
            <EuiFieldText value={cif} fullWidth name="txtCif" onChange={e => setCif(e.target.value)} isInvalid={false}/>
          </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
          <EuiFormRow label="Referencia" fullWidth isInvalid={false}>
            <EuiFieldText value={referencia} fullWidth name="txtReferencia" onChange={e => setReferencia(e.target.value)} isInvalid={false}/>
          </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow label="Pais" fullWidth isInvalid={isInvalidPais}>
          <ComboPaises fullWidth selectedOptions={pais} onChange={value => setPais(value)} isInvalid={isInvalidPais}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiFormRow fullWidth label="Fecha de baja">
          <SelectorFecha selected={fechaBaja} onChange={date => setFechaBaja(date)}  onClear={() => setFechaBaja(null)}/>
        </EuiFormRow>
      </EuiFlexItem>
      {/* <EuiFlexItem>
        <EuiFormRow fullWidth label="Tipo">
          <ComboTipoSociedad fullWidth valueOfSelected={tipo} onChange={value => setTipo(value)}/>
        </EuiFormRow>
      </EuiFlexItem> */}
      <EuiFlexItem grow={false}>
        <EuiFormRow fullWidth label="Facturación/Certficado">
            <EuiSwitch id='chk-facturacioncertificado' label='' checked={facturacionCertificado} 
            onChange={(e)=>setFacturacionCertificado(!facturacionCertificado)}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow fullWidth label="Domicilio Fiscal" isInvalid={false}>
            <EuiFieldText fullWidth value={domicilioFiscal} name="txtDomicilioFiscal" onChange={e => setDomicilioFiscal(e.target.value)} isInvalid={false}/>
          </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    {comprobarErrores() ? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{"Faltan campos por rellenar"}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="m" />

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
      
  )
}
export default Formulario;